import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { parse } from "query-string";
import * as React from "react";
import { Content } from "../components/content";
import { DocumentActionList } from "../components/document-action-list";
import { DocumentMetadataDisplay } from "../components/document-metadata-display";
import { withAuthContext } from "../components/with-auth-context";
import { withSnackbar } from "../components/with-snackbar";
import { DocumentPublishModel } from "../model/autogen/DocumentPublishModel";
import { MemberOfParliamentRequestFactory } from "../model/autogen/MemberOfParliamentController";
import { MemberOfParliamentModel } from "../model/autogen/MemberOfParliamentModel";
import { UserLevel } from "../model/autogen/UserLevel";
import { ItemPageProps } from "./debate-note-item-page";
import { MPEditRoute } from "../route-paths";
import { DocumentDisplay } from "../components/display/common";
import { PersonCard } from "../components/person-card";
import { QuoteModel } from "../model/autogen/QuoteModel";
import { QuoteRequestFactory } from "../model/autogen/QuoteController";
import { TweetRequestFactory } from "model/autogen/TweetController";
import { TweetModel } from "model/autogen/TweetModel";

export interface IMPProfilePageState {
    model: MemberOfParliamentModel | undefined;
    quotedIn: QuoteModel[];
    tweets: TweetModel[];
}

class MPProfileItemPageComponent extends React.Component<ItemPageProps, IMPProfilePageState> {
    constructor(props: ItemPageProps) {
        super(props);
        this.state = { model: undefined, quotedIn: [], tweets: [] };
    }
    public async componentDidMount() {
        this.loadContent()
    }
    public componentDidUpdate(prevProps: ItemPageProps) {
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.loadContent();
        }
    }
    private shouldIncludeDeleted(): boolean {
        const { includeDeleted } = parse(this.props.location.search);
        return this.props.user.level >= UserLevel.Editor && (!!includeDeleted == true);
    }
    private loadContent = async () => {
        const id = parseInt(this.props.match.params.id, 10);
        let model;
        try { 
            const result = await this.props.callApi((fetcher) => MemberOfParliamentRequestFactory.getById(fetcher, id, this.shouldIncludeDeleted()));
            if (result) {
                model = result
            }
        } catch (e) {
            window.location.href = '/page-not-found';
        }
        let quotedIn: QuoteModel[] = [];
        if (model != undefined) {
            if (model.person && model.person.id) {
                let modelId = model.person.id;
                quotedIn = await this.props.callApi((fetcher) => QuoteRequestFactory.getQuotes(fetcher, modelId));
            }
        }
        const tweets = await this.props.callApi((fetcher) => TweetRequestFactory.getTweets(fetcher, id));
        this.setState({ model, quotedIn, tweets });
    }

    private onPublishContent = async (e: any) => {
        if (this.state.model && confirm("Are you sure you want to publish this content?")) {
            this.props.showSnackbarMessage("Publishing content ...");
            const payload = {
                documentId: this.state.model.id
            } as DocumentPublishModel;
            const model = await this.props.callApi((fetcher) => MemberOfParliamentRequestFactory.publish(fetcher, payload));
            this.props.showSnackbarMessage("Content published");
            window.location.href = '/data/unpublished';
            this.setState({ model });
        }
    }
    private onDelete = async (e: any) => {
        const { model } = this.state;
        if (model && confirm("Are you sure you want to archive this content?")) {
            this.props.showSnackbarMessage("Archiving content ...");
            try {
                const result = await this.props.callApi((fetcher) => MemberOfParliamentRequestFactory.delete(fetcher, model.id));
                if (result) {
                    this.props.showSnackbarMessage("Content archive");
                    this.props.history.goBack();
                }
            } catch (e) {
                this.props.showSnackbarMessage(`Failed to archive content: ${e}`);
            }
        }
    }
    public render() {
        const { model, quotedIn, tweets } = this.state;
        if (!model) {
            return <LinearProgress />;
        }

        var personComponent = model.person ? <div>
            <h3>Person Details</h3>
            <PersonCard model={model.person} quotedIn={quotedIn} tweets={tweets} />
        </div> : <div>No Person Linked (predates MP/Person feature)</div> 

        return <Content>
            <DocumentMetadataDisplay model={model} />
            <DocumentDisplay item={model} extraComponents={() => personComponent} />

            <DocumentActionList editRoute={MPEditRoute(model.id)} model={model} user={this.props.user} onDelete={this.onDelete} onPublishContent={this.onPublishContent} />
        </Content>;
    }
}

export const MPProfileItemPage = withSnackbar(withAuthContext(MPProfileItemPageComponent) as any);


// WEBPACK FOOTER //
// ./src/pages/mp-profile-item-page.tsx